import { Signal } from '../../../types';
import SignalBadge from '../../../components/SignalBadge';
import ProgressBar from '../../../components/ProgressBar';
import { formatSignalType, formatTimeAgo } from '../utils/formatters';

interface SignalsSectionProps {
  signals: Signal[];
}

export default function SignalsSection({ signals }: SignalsSectionProps) {
  return (
    <div className="card">
      <h2 className="text-lg font-semibold mb-4">RLM Signals ({signals.length})</h2>
      {signals.length === 0 ? (
        <p className="text-gray-400 text-center py-4">No signals detected</p>
      ) : (
        <div className="space-y-3 max-h-80 overflow-y-auto">
          {signals.map((signal) => (
            <div
              key={signal.id}
              className={`p-3 rounded-lg ${
                signal.isActive ? 'bg-surface-50' : 'bg-surface-50/50'
              }`}
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <SignalBadge type={signal.signalType} showLabel={false} />
                  <div>
                    <div className="font-medium text-sm">
                      {formatSignalType(signal.signalType)}
                    </div>
                    <div className="text-xs text-gray-400">
                      {signal.direction} • {formatTimeAgo(signal.detectedAt)}
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-sm font-medium">
                    {(signal.strength * 100).toFixed(0)}%
                  </div>
                  <div className="text-xs text-gray-400">
                    {signal.isActive ? 'Active' : 'Expired'}
                  </div>
                </div>
              </div>
              <div className="mt-2">
                <ProgressBar
                  label=""
                  value={signal.strength * 100}
                  max={100}
                  showValue={false}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
